import { createItemToLocation } from './createItemToLocation';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const transformSectionToLocationItems = (
  name: string,
  section?: { items: ICDV3ViewItem[] } | null,
  offset?: number
) => (section ? section.items.map(createItemToLocation(name, offset)) : []);
